// import firebase from "firebase";
import db from "./db.js";
import axios from "axios";
import { OlabUtils } from "./olabutils.js";
import { OlabSequence } from "./olabsequence.js";
import { OlabItem } from "./olabitem.js";
import { OlabGene } from "./olabgene.js";
import { OlabBlock } from "./olabblock.js";

class OlabDataFile {
  constructor(df) {
    OlabUtils.infoLog("OlabDataFile.constructor() ...");
    this.olab_id = df.olab_id;
    this.name = null;
  }

  static computeCount(c, seq) {
    let cnt = 0;
    for (let i = 0; i < seq.length; i++) {
      if (seq[i].toUpperCase() == c) {
        cnt++;
      }
    }
    return cnt;
  }

  static computeSeqStat(seq) {
    // Compute seq's gene_stats
    const numA = OlabDataFile.computeCount("A", seq);
    const numC = OlabDataFile.computeCount("C", seq);
    const numG = OlabDataFile.computeCount("G", seq);
    const numT = OlabDataFile.computeCount("T", seq);
    let shortSeq = seq.substring(0, 25);
    if (seq.length > 25) {
      shortSeq = shortSeq + "...";
    }
    const stat = {
      len: seq.length,
      num_a: numA,
      num_c: numC,
      num_g: numG,
      num_t: numT,
      short_seq: shortSeq
    };
    return stat;
  }

  // Load RBS data to Firebase
  static loadRBSData(name, dataArr) {
    return new Promise(resolve => {
      OlabUtils.infoLog("Load file = " + name);
      // Set timeout of 1 milliseconds
      setTimeout(resolve, 1);
      // Load the genes to Firebase
      axios.get(name).then(response => {
        const items = response.data;
        for (let i = 0; i < items.length; i++) {
          OlabUtils.infoLog(
            "items " + i + ": " + items[i].Name + ", " + items[i].RBS
          );
          const item = new OlabItem();

          const iInHex = i.toString(16).toUpperCase();
          OlabUtils.infoLog("iInHex = " + iInHex);
          item.olab_id = "LR-" + iInHex.toString().padStart(5, "0");

          item.name = items[i].Name;
          // append unique key to name_uc for search to work later
          if (item.name != null) {
            item.name_uc = item.name.toUpperCase() + " ^%#- " + item.olab_id;
          } else {
            item.name_uc = null;
          }
          item.seq = items[i].RBS.toUpperCase();
          item.olab_type = "library_sequence";
          item.creator = "chien.yang@olabbio.com";
          // append unique key to creator_uc for search to work later
          if (item.creator != null) {
            item.creator_uc =
              item.creator.toUpperCase() + " ^%#- " + item.olab_id;
          } else {
            item.creator_uc = null;
          }
          item.desc = "CJ RBS #" + (i + 1);
          item.library_id = "LR";
          item.seq_origin = "UDS - User Defined Sequence";
          item.source = "inhouse";
          item.gene_stats = OlabDataFile.computeSeqStat(item.seq);

          dataArr.push(item);
        }

        OlabDataFile.uploadRBSDataToFB(dataArr);
      });
    });
  }

  static async uploadRBSDataToFB(dataArr) {
    for (let i = 0; i < dataArr.length; i++) {
      console.log(i + " seconds");
      await OlabDataFile.uploadRBSDataWithTimer(dataArr[i], 1, i);
    }
  }

  static uploadRBSDataWithTimer(data, ms, index) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
      OlabUtils.infoLog(
        "XXX millseconds = " +
          ms +
          ", Index = " +
          index +
          ", olab_id = " +
          data.olab_id
      );
      // NOTE: FIXME - Replace hardcoded path
      db.collection("libraries/LR/olab_items")
        .withConverter(OlabSequence.getCreateItemConverter())
        .doc(data.olab_id)
        .set(data, { merge: true })
        .then(function() {
          OlabUtils.infoLog("Document successfully written! Index = " + index);
        })
        .catch(function(error) {
          OlabUtils.infoLog("Error writing document: " + error);
        });
    });
  }

  // Load Gene Update data to Firebase
  static uploadGeneData(
    microbeID,
    strainID,
    chromosomeID,
    startID,
    name,
    dataArr,
    blockConfig
  ) {
    return new Promise(resolve => {
      OlabUtils.infoLog("Load file = " + name);
      // Set timeout of 1 milliseconds
      setTimeout(resolve, 1);
      // Load the genes to Firebase
      axios.get(name).then(response => {
        const genes = response.data;
        for (let i = 0; i < genes.length; i++) {
          // OlabUtils.infoLog("genes " + i + ": " + genes[i].Name + ", " + genes[i].Short_Seq);
          const gene = new OlabGene();

          gene.olab_id =
            chromosomeID + "-" + startID.toString().padStart(4, "0");
          startID++;
          OlabUtils.infoLog("gene " + i + " = " + gene.olab_id);

          gene.name = genes[i].Name;
          if (gene.name != null) {
            gene.name_uc = gene.name.toUpperCase() + " ^%#- " + gene.olab_id;
          } else {
            gene.name_uc = null;
          }
          gene.synonym_name1 = genes[i].Synonym_Name1;
          if (gene.synonym_name1 != null) {
            gene.synonym_name1_uc =
              gene.synonym_name1.toUpperCase() + " ^%#- " + gene.olab_id;
          } else {
            gene.synonym_name1_uc = null;
          }
          gene.synonym_name2 = genes[i].Synonym_Name2;
          if (gene.synonym_name2 != null) {
            gene.synonym_name2_uc =
              gene.synonym_name2.toUpperCase() + " ^%#- " + gene.olab_id;
          } else {
            gene.synonym_name2_uc = null;
          }
          gene.synonym_name3 = genes[i].Synonym_Name3;
          if (gene.synonym_name3 != null) {
            gene.synonym_name3_uc =
              gene.synonym_name3.toUpperCase() + " ^%#- " + gene.olab_id;
          } else {
            gene.synonym_name3_uc = null;
          }
          gene.synonym_name4 = genes[i].Synonym_Name4;
          if (gene.synonym_name4 != null) {
            gene.synonym_name4_uc =
              gene.synonym_name4.toUpperCase() + " ^%#- " + gene.olab_id;
          } else {
            gene.synonym_name4_uc = null;
          }
          gene.synonym_name5 = genes[i].Synonym_Name5;
          if (gene.synonym_name5 != null) {
            gene.synonym_name5_uc =
              gene.synonym_name5.toUpperCase() + " ^%#- " + gene.olab_id;
          } else {
            gene.synonym_name5_uc = null;
          }
          gene.short_seq = genes[i].Short_Seq.toUpperCase();
          gene.b_number = genes[i].B_Number ? genes[i].B_Number : null;
          if (gene.b_number != null) {
            gene.b_number_uc = gene.b_number.toUpperCase();
          } else {
            gene.b_number_uc = null;
          }
          gene.locus_tag = genes[i].Locus_Tag;
          gene.old_locus_tag = genes[i].Old_Locus_Tag;
          if (gene.old_locus_tag != null) {
            gene.old_locus_tag_uc = gene.old_locus_tag.toUpperCase();
          } else {
            gene.old_locus_tag_uc = null;
          }

          gene.sequence = {};
          const geneStart = parseInt(genes[i].Start, 10);
          const geneEnd = parseInt(genes[i].End, 10);
          const comp = geneStart > geneEnd ? "true" : "false";
          gene.sequence.comp = comp;
          gene.sequence.from = comp == "true" ? geneEnd : geneStart;
          gene.sequence.to = comp == "true" ? geneStart : geneEnd;
          OlabUtils.infoLog(
            "comp = " + comp + ", gene.sequence.comp = " + gene.sequence.comp
          );
          OlabUtils.infoLog("Start = " + geneStart + ", End = " + geneEnd);
          OlabUtils.infoLog(
            "from = " +
              gene.sequence.from +
              ", gene.sequence.to= " +
              gene.sequence.to
          );

          gene.sequence.type = genes[i].Type == "" ? "CDS" : genes[i].Type;
          gene.desc = "CJ internal version";
          // Note: gene's seq is computed later in uploadGeneDataToFB
          dataArr.push(gene);
        }

        OlabDataFile.uploadGeneDataToFB(
          microbeID,
          strainID,
          dataArr,
          blockConfig
        );
      });
    });
  }

  static async uploadGeneDataToFB(microbeID, strainID, dataArr, blockConfig) {
    for (let i = 0; i < dataArr.length; i++) {
      await OlabBlock.fillGeneSeqAndUpload(
        microbeID,
        strainID,
        dataArr[i],
        blockConfig
      );
    }
  }

  // Reset b_number, locus_tag and synonym_nameX
  static resetGeneData(microbeID, strainID, chromosomeID, startID, endID) {
    for (let i = startID; i < endID; i++) {
      const id = chromosomeID + "-" + startID.toString().padStart(4, "0");
      startID++;
      setTimeout(() => {
        OlabUtils.infoLog("gene " + i + " = " + id);
      }, 50);

      const collectionStr =
        "microbes/" + microbeID + "/olab_items/" + strainID + "/olab_genes";

      db.collection(collectionStr)
        .withConverter(OlabGene.getOlabGeneConverter())
        .doc(id)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            // OlabGene.infoLog(doc.data());
            const gene = doc.data();
            gene.synonym_name1 = null;
            gene.synonym_name1_uc = null;
            gene.synonym_name2 = null;
            gene.synonym_name2_uc = null;
            gene.synonym_name3 = null;
            gene.synonym_name3_uc = null;
            gene.synonym_name4 = null;
            gene.synonym_name4_uc = null;
            gene.synonym_name5 = null;
            gene.synonym_name5_uc = null;
            gene.b_number = null;
            gene.b_number_uc = null;
            gene.locus_tag = null;
            gene.old_locus_tag = null;
            gene.old_locus_tag_uc = null;
            gene.sequence.type = "chromosome";

            OlabUtils.infoLog("XXX  gene.olab_id = " + gene.olab_id);

            db.collection(collectionStr)
              .withConverter(OlabGene.getOlabGeneConverter())
              .doc(gene.olab_id)
              .set(gene, { merge: true })
              .then(function() {
                OlabUtils.infoLog(
                  "Document successfully written! gene.olab_id = " +
                    gene.olab_id
                );
              })
              .catch(function(error) {
                OlabUtils.infoLog("Error writing document: " + error);
              });
          } else {
            // doc.data() will be undefined in this case
            OlabUtils.infoLog("No such document!");
          }
        })
        .catch(function(error) {
          OlabUtils.infoLog("Error getting document: " + error);
        });
    }
  }

  // Load gene's block files to Firebase
  static async loadGeneBlockFiles(
    fileName,
    microbeID,
    strainID,
    chromosome_id,
    from,
    to,
    dataArr
  ) {
    for (let i = from; i < to; i++) {
      OlabUtils.infoLog("Load file = " + fileName);
      const cName = fileName + i + ".json";
      // index is i
      await OlabDataFile.loadGeneBlockFile(
        cName,
        microbeID,
        strainID,
        chromosome_id,
        dataArr,
        i
      );
    }
  }

  static loadGeneBlockFile(
    name,
    microbeID,
    strainID,
    chromosome_id,
    dataArr,
    id
  ) {
    return new Promise(resolve => {
      OlabUtils.infoLog("Load file = " + name);
      // Set timeout of 5 milliseconds
      setTimeout(resolve, 5);
      // Load the genes to Firebase
      axios.get(name).then(response => {
        const data = response.data;

        OlabUtils.infoLog("data : " + data.block);

        const item = {};

        item.olab_id =
          microbeID +
          "-" +
          strainID +
          "-" +
          chromosome_id +
          "-" +
          id.toString().padStart(4, "0");

        item.block = data.block;
        item.start = data.start;
        item.range = data.range;
        item.seq = data.seq.toUpperCase();
        item.prev_block = data.prev_block;
        item.next_block = data.next_block;

        dataArr.push(item);
        OlabUtils.infoLog(
          "dataArr.length " +
            dataArr.length +
            ": " +
            dataArr[dataArr.length - 1].olab_id
        );

        OlabDataFile.uploadGeneBlockToFB(microbeID, strainID, item);
      });
    });
  }

  static async uploadGeneBlockToFB(microbeID, strainID, data) {
    await OlabDataFile.uploadGeneBlockWithTimer(microbeID, strainID, data, 5);
  }

  static uploadGeneBlockWithTimer(microbeID, strainID, data, ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
      OlabUtils.infoLog(
        "XXX millseconds = " + ms + ", olab_id = " + data.olab_id
      );
      db.collection(
        "microbes/" +
          microbeID +
          "/olab_items/" +
          microbeID +
          "-" +
          strainID +
          "/olab_blocks"
      )
        .doc(data.olab_id)
        .set(data, { merge: true })
        .then(function() {
          OlabUtils.infoLog("Document successfully written!");
        })
        .catch(function(error) {
          OlabUtils.infoLog("Error writing document: " + error);
        });
    });
  }

  static infoLog(df) {
    OlabUtils.infoLog(" - df.olab_id = " + df.olab_id);
    OlabUtils.infoLog(" - df.name = " + df.name);
  }
}

export { OlabDataFile };
